import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { TipoGastosCreateComponent } from '../tipo-gastos-create/tipo-gastos-create.component';
import { TipoGastosUpdateComponent } from '../tipo-gastos-update/tipo-gastos-update.component';
import { TipoGastosService } from '../tipo-gastos.service';

@Component({
  selector: 'app-tipo-gastos-index',
  templateUrl: './tipo-gastos-index.component.html',
  styleUrls: ['./tipo-gastos-index.component.scss']
})
export class TipoGastosIndexComponent implements OnInit {

  filtros = [
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'substring'
    },
    {
      label: 'Descripción',
      column: 'descripcion',
      op: 'substring'
    }
  ]

  columnas: any[] = [

    {
      label: "Nombre",
      attribute: "nombre",
      responsive: ['XS', 'SM', 'MD'],
    },
    {
      label: "Descripción",
      attribute: "descripcion"
    }
  ]
  acciones: any[] = [

    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    },
    {
      label: 'Eliminar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }

  ]

  reloadEmitter: EventEmitter<string> = new EventEmitter();
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: TipoGastosService,
    public sesion: SesionService
  ) { }

  ngOnInit(): void { }

  agregar() {
    this.modalService.open(TipoGastosCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }

  update(element: any) {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(TipoGastosUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  delete(element: any) {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Tipo de Gasto';
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar el tipo de gasto '${element.nombre}'?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show()
      this.service.delete(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
          this.alerts.addAlert('El Tipo de Gasto se eliminó con éxito.', 'success');
        },
        error: err => {
          console.error(err);
          this.loading.hide();
          if (err.error) this.formatter.showErrorAlerts(err.error);
        }
      });
    }, (reason: any) => { });
  }
}
